// Builds a getOptions(accessorKey) resolver backed by the `table_columns` API
// response. This is the single source of truth for filter dropdown options —
// it replaces the old hardcoded `filterOptions.js` fallback.
//
//   - Global-managed columns (custom_options: false) return their shared global
//     list (municipality_id: null, managed from the admin "Manage Options" UI).
//   - Data-driven columns (custom_options: true) return the current
//     municipality's options.
export const makeGetColumnOptions = (tableColumns, municipality) => (accessorKey) => {
  const column = tableColumns?.find((tc) => tc.accessor_key === accessorKey)

  if (!column?.filter_options) {
    return []
  }

  if (column.custom_options) {
    return column.filter_options[municipality?.id] || []
  }

  if (column.filter_options.nil) {
    return column.filter_options.nil
  }

  return []
}
